/**
 * Dernière méthode de connexion choisie sur cet appareil (« Numéro WhatsApp » ou « E-mail »).
 *
 * Confort uniquement : le stockage du navigateur peut être absent ou bloqué (navigation privée, données
 * effacées) — toute lecture et toute écriture sont protégées, et le défaut est WhatsApp (au Mali le numéro
 * sert plus que l'e-mail).
 */
import type { MethodeConnexion } from '../../../../../web-commun/connexion-whatsapp/BasculeMethode'

export const CLE_METHODE_CONNEXION = 'swifteats.methode-connexion'
export const METHODE_PAR_DEFAUT: MethodeConnexion = 'whatsapp'

type Stockage = Pick<Storage, 'getItem' | 'setItem'>

function stockageNavigateur(): Stockage | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null
  } catch {
    return null
  }
}

export function lireMethode(stockage: Stockage | null = stockageNavigateur()): MethodeConnexion {
  try {
    const v = stockage?.getItem(CLE_METHODE_CONNEXION)
    return v === 'email' || v === 'whatsapp' ? v : METHODE_PAR_DEFAUT
  } catch {
    return METHODE_PAR_DEFAUT
  }
}

export function memoriserMethode(m: MethodeConnexion, stockage: Stockage | null = stockageNavigateur()): void {
  try {
    stockage?.setItem(CLE_METHODE_CONNEXION, m)
  } catch {
    /* stockage bloqué : sans conséquence */
  }
}
